import React from 'react';
import { useColorResolver } from "../use/useColorResolver.mjs";
import { useForkRef } from "../ref.mjs";
import assignProps from "../assignProps.mjs";
var resolveColorEnhance = function resolveColorEnhance() {
  return function (props) {
    var ref = props.ref;
    var internalRef = React.useRef();
    var resolveColor = useColorResolver();
    return assignProps(props, {
      ref: useForkRef(ref, internalRef),
      resolveColor: resolveColor
    });
  };
};
export default resolveColorEnhance;
//# sourceMappingURL=resolveColorEnhance.mjs.map